import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from '../../apis'

/**
 * Service to fetch all site properties
 */
export const getAllSitePropertiesService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/admins/site-properties', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

/**
 * Service to update site properties
 */
export const updateSitePropertiesService = (data) => {
  return axiosInstance(METHOD_TYPES.put, '/admins/site-properties', data, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'Properties Updated Successfully'
  })
}
